var map = {
	"./web_app_aa.json": "2284",
	"./web_app_de.json": "b6b0",
	"./web_app_en.json": "1ab8",
	"./web_app_es.json": "155c",
	"./web_app_ja.json": "7f23",
	"./web_app_nl.json": "2956",
	"./web_app_pl.json": "1c9e",
	"./web_app_pt.json": "dee7",
	"./web_app_tr.json": "3f02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5c0";